import "./WalletSubform.scss";

import { Box, Grid, Typography } from "@material-ui/core";
import FlashIcon from "common/assets/icons/Flash.svg";
import { UserField, UserInputTypeKey } from "common/components/input/fields";
import { SubformProps } from "common/components/SubformProps";
import { UpdateUserManageable, UserManageable } from "common/store/user/types";
import React from "react";
import { useTranslation } from "react-i18next";

interface WalletSubformProps extends SubformProps<UpdateUserManageable> {
  user: UserManageable;
}

export const WalletSubform = (props: WalletSubformProps) => {
  const { t } = useTranslation();

  const { user } = props;

  return (
    <Grid item container direction="column" spacing={4}>
      {!user.wallet &&
      <Grid item xs={12}>
        <Typography className="justified-text" variant="body1" color="textSecondary">
          {t("All tokens purchased via the FinPro platform are stored on a private Ethereum blockchain in so-called smart contracts in a decentralized and secure manner. A wallet is required to access these tokens, which can only be accessed by means of a decryption key (so-called private key). This user-specific private key is stored encrypted in a separate environment of the FinPro database and can only be decrypted and made usable by entering your wallet password. More information about our wallet, private keys, and how they and our platform's blockchain-based processes work please find here.")}
        </Typography>
      </Grid>
      ||
      <Grid item xs={12}>
        <Typography className="justified-text" variant="body1" color="textSecondary">
          {t("Your tokens will be stored securely in your wallet on a blockchain after purchase. To confirm that this is your wallet, please enter the wallet password.")}
        </Typography>
      </Grid>
      }

      {!user.wallet &&
      <Grid item xs={12}>
        <Typography className="justified-text" variant="body1" color="textSecondary">
          {t("Please note that your wallet password is not the same as your FinPro platform password.")}
        </Typography>
      </Grid>
      ||
      <Grid item xs={12}>
        <Typography className="justified-text" variant="body1" color="textSecondary">
          {t("Note that your wallet password is not the same as your FinPro platform password.")}
        </Typography>
      </Grid>
      }

      <Grid item xs={12}>
        <UserField
          id={"walletPassword" as UserInputTypeKey}
          {...props}
        />
      </Grid>

      {!user.wallet &&
      <Grid item xs={12}>
        <UserField
          id={"confirmWalletPassword" as UserInputTypeKey}
          {...props}
        />
      </Grid>
      }

      {!user.wallet &&
      <Grid container direction="column" spacing={2} item>
        <Grid item>
          <Typography className="justified-text" variant="body1" color="textSecondary">
            {!user.wallet ? t("Please confirm your FinPro platform password") : t("Please confirm the creation of your wallet password by entering your FinPro platform password")}
          </Typography>
        </Grid>

        <Grid item>
          <UserField
            id={"password" as UserInputTypeKey}
            {...props}
          />
        </Grid>
      </Grid>
      }

      {!user.wallet &&
      <Grid item xs={12}>
        <Box display="flex">
          <img
            className="flash"
            src={FlashIcon}
            alt="flash"
          />

          <Typography className="justified-text flashText">
            {t("Please be sure to write down your wallet password and keep it in a safe place! Without wallet password no access to your tokens will be possible anymore! Resetting or re-creating your wallet password will not be possible due to legal reasons.")}
          </Typography>
        </Box>
      </Grid>
      }
    </Grid>
  );
};
